/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import Modal from '/client/src/components/Modal';
import { POST } from '/client/src/api';
import BtnLoader from '/client/src/components/btns/circularProgress/';
import { setValidateClass } from '/client/src/utils/animation';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import { timeerOffModal } from '/client/src/constants/';

import './styles.scss';

type PropsType = {
  isOpen: boolean,
  handleToggleResetPassModal: (boolean) => void
};

class ResetPassModal extends React.Component<PropsType> {
  static contextType = DefaultContainerContext;

  state = {
    oldPass: '',
    oldPassNotValid: false,
    newPass: '',
    newPassNotValid: false,
    confirmNewPass: '',
    isErrorEqual: false,
    isLocked: false
  };

  handleClose = (): any => {
    const { handleToggleResetPassModal } = this.props;

    handleToggleResetPassModal(false);
  };

  handleChangeInput = (e: SyntheticEvent<HTMLInputElement>) => {
    const name = e.target.id;
    const value = e.target.value;
    const el = e.target;

    this.setState({
      [name]: value
    }, () => {
      this.validate(el);
    });
  };

  validate = (el: HTMLInputElement) => {
    if (el.id === 'confirmNewPass') {
      this.setState({ isErrorEqual: this.state.newPass !== this.state.confirmNewPass });
    }

    if (el.id === 'newPass') {
      if (this.state.newPass === this.state.confirmNewPass) {
        this.setState({
          confirmNewPass: '',
          isErrorEqual: false
        });
      }
    }

    const _name = `${el.id}NotValid`;

    this.setState({
      [_name]: !_.size(el.value)
    }, () => {
      // Validate and shake if field is empty
      setValidateClass(el);
    });
  };

  handleSave = async (setStatus: (string) => void) => {
    const {
      isLocked,
      oldPassNotValid,
      newPassNotValid,
      isErrorEqual
    } = this.state;

    if (isLocked) {
      console.warn('Already locked');
      return;
    }

    if (oldPassNotValid || newPassNotValid || isErrorEqual) {
      console.warn('Blocked by validation');
      setValidateClass(this.oldPass);
      setValidateClass(this.newPass);
      setValidateClass(this.confirmNewPass);
      return;
    }

    this.setState({
      isLocked: true
    }, () => {
      setStatus('loading');
    });

    const data = {
      'current_password': this.state.oldPass,
      'password': this.state.newPass
    };

    try {
      const { success } = await POST('/api/v1/1/account/change_password', data);

      if (success) {
        this.setState({
          isLocked: false
        }, () => {
          setStatus('success');

          this.handleClose();

          this.context.handleShowSystemDialog(true, {
            systemDialogType: 'success',
            systemDialogTitle: 'Great!',
            systemDialogContent: 'Successfully changed'
          });
        });
      }
    } catch (error) {
      this.setState({
        isLocked: false
      }, () => {
        this.context.handleShowSystemDialog(true, {
          systemDialogType: 'error',
          systemDialogTitle: 'Error!',
          systemDialogContent: 'Password is invalid'
        });

        setStatus('error');
        console.error(error);

        setTimeout(() => {
          setStatus('');
        }, timeerOffModal * 3);
      });
    }
  }

  render(): React.Element {
    const { isOpen } = this.props;
    const {
      oldPass,
      oldPassNotValid,
      newPass,
      newPassNotValid,
      confirmNewPass,
      isErrorEqual,
      isLocked
    } = this.state;

    return (
      <>
        {isOpen ?
          <Modal
            opened={isOpen}
            onClose={this.handleClose}
          >
            <div className="modal-dialog customModal ResetPassModal" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h4 className="modal-title">Reset password</h4>
                </div>
                <div className="modal-body" style={{ cursor: isLocked ? 'not-allowed' : 'auto' }}>

                  <form style={isLocked ? { pointerEvents: 'none' } : {}}>
                    <div className="form-group">
                      <label htmlFor="oldPass">Old Password</label>
                      <div className="input-group">
                        <input
                          type="password"
                          className="form-control"
                          id='oldPass'
                          value={oldPass}
                          onChange={this.handleChangeInput}
                          ref={((node: HTMLInputElement) => {
                            this.oldPass = node;
                          })}
                        />
                        <span
                          className="input-group-addon"
                          onClick={(e: any) => {
                            const inputEl = e.currentTarget.previousSibling;
                            const icon = e.currentTarget.querySelector('i');
                            const currentType = inputEl.getAttribute('type');

                            inputEl.setAttribute('type', currentType === 'text' ? 'password' : 'text');
                            icon.setAttribute(
                              'class',
                              currentType === 'text' ? 'glyphicon glyphicon-eye-open' : 'glyphicon glyphicon-eye-close'
                            );
                          }}
                        >
                          <i className="glyphicon glyphicon-eye-open" />
                        </span>
                      </div>
                      {oldPassNotValid ?
                        <span
                          className="validationMessage"
                        >This field is required.</span> :
                        null
                      }

                    </div>

                    <div className="form-group">
                      <label htmlFor="newPass">New Password</label>
                      <div className="input-group">
                        <input
                          type="password"
                          className="form-control"
                          id='newPass'
                          value={newPass}
                          onChange={this.handleChangeInput}
                          ref={((node: HTMLInputElement) => {
                            this.newPass = node;
                          })}
                        />
                        <span
                          className="input-group-addon"
                          onClick={(e: any) => {
                            const inputEl = e.currentTarget.previousSibling;
                            const icon = e.currentTarget.querySelector('i');
                            const currentType = inputEl.getAttribute('type');

                            inputEl.setAttribute('type', currentType === 'text' ? 'password' : 'text');
                            icon.setAttribute(
                              'class',
                              currentType === 'text' ? 'glyphicon glyphicon-eye-open' : 'glyphicon glyphicon-eye-close'
                            );
                          }}
                        >
                          <i className="glyphicon glyphicon-eye-open" />
                        </span>
                      </div>
                      {newPassNotValid ?
                        <span
                          className="validationMessage"
                        >This field is required.</span> :
                        null
                      }
                    </div>

                    <div className="form-group">
                      <label htmlFor="confirmNewPass">Confirm New Password</label>
                      <div className="input-group">
                        <input
                          type="password"
                          className="form-control"
                          id='confirmNewPass'
                          value={confirmNewPass}
                          onChange={this.handleChangeInput}
                          ref={((node: HTMLInputElement) => {
                            this.confirmNewPass = node;
                          })}
                        />
                        <span
                          className="input-group-addon"
                          onClick={(e: any) => {
                            const inputEl = e.currentTarget.previousSibling;
                            const icon = e.currentTarget.querySelector('i');
                            const currentType = inputEl.getAttribute('type');

                            inputEl.setAttribute('type', currentType === 'text' ? 'password' : 'text');
                            icon.setAttribute(
                              'class',
                              currentType === 'text' ? 'glyphicon glyphicon-eye-open' : 'glyphicon glyphicon-eye-close'
                            );
                          }}
                        >
                          <i className="glyphicon glyphicon-eye-open" />
                        </span>
                      </div>
                      {isErrorEqual ?
                        <span
                          className="validationMessage"
                        >New Password fields must match.</span> :
                        null
                      }
                    </div>
                  </form>

                </div>
                <div className="modal-footer">
                  <button className="btn btn-gray" onClick={this.handleClose}>Close</button>

                  <span className='custom-pb-container'>
                    <BtnLoader
                      label='Reset'
                      handleCallBack={(e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void) => {
                        this.handleSave(setStatus);
                      }}
                    />
                  </span>
                  {/* <button className="btn btn-pink">Reset</button> */}
                </div>
              </div>
            </div>
          </Modal>
        : null}
      </>

    );
  }
}

export default ResetPassModal;
